module.exports = __webpack_public_path__ + "static/img/cMRIp3.25e2d26c.png";